var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('uc-input', {
    ref: "inputRef",
    staticClass: "country-code-picker",
    attrs: {
      "label-variant": true,
      "outlined": true,
      "label": _vm.localLabel,
      "classes": _vm.isPhoneNumber ? ['left-no-radius'] : [],
      "error-messages": _vm.errorMessages,
      "disabled": _vm.disabled,
      "readonly": _vm.readonly,
      "hide-details": _vm.hideDetails,
      "can-double-click-to-edit": _vm.canDoubleClickToEdit,
      "validate-on-blur": true,
      "rules": _vm.isPhoneNumber ? _vm.phoneRules : _vm.emailRules,
      "read-mode-empty-state": _vm.readModeEmptyState
    },
    on: {
      "input": _vm.inputChanged,
      "blur": function ($event) {
        _vm.isPhoneNumber && _vm.formatNumber();
        _vm.$emit('blur', _vm.localValue);
      }
    },
    scopedSlots: _vm._u([_vm.isPhoneNumber ? {
      key: "prepend",
      fn: function () {
        return [_c('uc-select', {
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "hide-details": true,
            "label-variant": false,
            "outlined": true,
            "items": _vm.countryList,
            "item-text": "name",
            "item-value": "iso2",
            "autocomplete": true,
            "classes": ['right-no-radius'],
            "disabled": _vm.disabled,
            "data-cy": "select-country"
          },
          on: {
            "change": function ($event) {
              !_vm.localValue.length && _vm.updatePlaceholder();
            }
          },
          scopedSlots: _vm._u([{
            key: "selection",
            fn: function () {
              return [_c('div', {
                staticClass: "vti__flag",
                class: _vm.selectedCountry.iso2.toLowerCase()
              })];
            },
            proxy: true
          }, {
            key: "item",
            fn: function ({
              data
            }) {
              return [_c('span', {
                staticClass: "vti__flag",
                class: data.iso2.toLowerCase()
              }), _c('span', [_vm._v(_vm._s(data.name) + " " + _vm._s(`+${data.dialCode}`))])];
            }
          }], null, false, 2230335036),
          model: {
            value: _vm.selectedCountry,
            callback: function ($$v) {
              _vm.selectedCountry = $$v;
            },
            expression: "selectedCountry"
          }
        })];
      },
      proxy: true
    } : null], null, true),
    model: {
      value: _vm.localValue,
      callback: function ($$v) {
        _vm.localValue = $$v;
      },
      expression: "localValue"
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };